
import ImgLoader from '@/components/core/img-loader/img-loader.vue';

export default {
  name: 'MuscleLogo',
  components: {
    ImgLoader,
  },
};
